import React from 'react';
import PropTypes from 'prop-types';

function SupportNumberScreenreader({screenReaderSupportText, screenReaderSupportNumber}) {
    if (!screenReaderSupportText && !screenReaderSupportNumber) {
        return null;
    }

    const accessibilityText = `${screenReaderSupportText}${screenReaderSupportNumber}`;

    return (
        <a className="sr-only" href={`tel:${screenReaderSupportNumber}`}>
            {accessibilityText}
        </a>
    );
}

SupportNumberScreenreader.propTypes = {
    screenReaderSupportText: PropTypes.string,
    screenReaderSupportNumber: PropTypes.string
};

export {SupportNumberScreenreader};
